import type { Template } from "@/types";

export const LA_05_H5_V0: Template[] = [
    {
        id: "la-05-h5v0-01",
        name: "LA 01 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 98, y: 95, width: 237, height: 168, rotation: 0, imageRotation: 0 },
            { id: "2", x: 98, y: 271, width: 237, height: 167, rotation: 0, imageRotation: 0 },
            { id: "3", x: 343, y: 95, width: 236, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 271, width: 236, height: 167, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 95, width: 480, height: 342, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-02",
        name: "LA 02 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 94, y: 42, width: 487, height: 318, rotation: 0, imageRotation: 0 },
            { id: "2", x: 94, y: 367, width: 157, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 259, y: 367, width: 157, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 424, y: 367, width: 157, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 735, y: 73, width: 557, height: 388, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-03",
        name: "LA 03 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 224, y: 53, width: 229, height: 137, rotation: 0, imageRotation: 0 },
            { id: "2", x: 224, y: 198, width: 229, height: 136, rotation: 0, imageRotation: 0 },
            { id: "3", x: 224, y: 343, width: 229, height: 136, rotation: 0, imageRotation: 0 },
            { id: "4", x: 854, y: 53, width: 321, height: 209, rotation: 0, imageRotation: 0 },
            { id: "5", x: 854, y: 270, width: 321, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-04",
        name: "LA 04 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 131, y: 194, width: 204, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 237, y: 45, width: 204, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 237, y: 344, width: 204, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 343, y: 194, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 749, y: 80, width: 532, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-05",
        name: "LA 05 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 167, width: 264, height: 198, rotation: 0, imageRotation: 0 },
            { id: "2", x: 272, y: 167, width: 264, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 544, y: 167, width: 264, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 816, y: 167, width: 264, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1088, y: 167, width: 264, height: 198, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-06",
        name: "LA 06 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 40, y: 173, width: 248, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 173, width: 248, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 552, y: 173, width: 248, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 808, y: 173, width: 248, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1064, y: 173, width: 248, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-07",
        name: "LA 07 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 436, y: 36, width: 647, height: 458, rotation: 0, imageRotation: 0 },
            { id: "2", x: 270, y: 386, width: 158, height: 109, rotation: 0, imageRotation: 0 },
            { id: "3", x: 270, y: 269, width: 158, height: 109, rotation: 0, imageRotation: 0 },
            { id: "4", x: 270, y: 153, width: 158, height: 109, rotation: 0, imageRotation: 0 },
            { id: "5", x: 270, y: 36, width: 158, height: 109, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-08",
        name: "LA 08 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 41, y: 55, width: 593, height: 420, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 55, width: 293, height: 206, rotation: 0, imageRotation: 0 },
            { id: "3", x: 717, y: 269, width: 293, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1018, y: 55, width: 292, height: 206, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 269, width: 292, height: 205, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-09",
        name: "LA 09 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 49, y: 45, width: 308, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 270, width: 308, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 365, y: 45, width: 622, height: 441, rotation: 0, imageRotation: 0 },
            { id: "4", x: 995, y: 45, width: 307, height: 217, rotation: 0, imageRotation: 0 },
            { id: "5", x: 995, y: 270, width: 307, height: 216, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h5v0-10",
        name: "LA 10 - H5V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h5_v0_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 50, y: 45, width: 308, height: 217, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 270, width: 308, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 366, y: 45, width: 307, height: 217, rotation: 0, imageRotation: 0 },
            { id: "4", x: 366, y: 270, width: 307, height: 216, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 45, width: 622, height: 441, rotation: 0, imageRotation: 0 }
        ],
    }
];